
        import * as module0 from './controllers/anchor_copy_controller.js';import * as module1 from './controllers/code_copy_controller.js';import * as module2 from './controllers/example_controller.js';import * as module3 from './controllers/search_controller.js'
        const modules = {
            "./controllers/anchor_copy_controller.js": module0,
            "./controllers/code_copy_controller.js": module1,
            "./controllers/example_controller.js": module2,
            "./controllers/search_controller.js": module3,
        };
        export default modules;
      